export default "__VITE_ASSET__c450f834__"